import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { toggleDrawer } from '../../helpers/helpers.js'

// Translations
import translate from '../Translate.js';

// Dependencies
import moment from 'moment';

// Components
import ExamCardClosed from './ExamCardClosed';
import ExamCardNeedsProctor from './ExamCardNeedsProctor';
import ExamCardScheduled from './ExamCardScheduled';
import AutomatedExamCard from './AutomatedExamCard';

const StudentExamCard = observer(class StudentExamCard extends React.Component {
  constructor() {
    super();
    this.messageInstructor = this.messageInstructor.bind(this);
  }


   componentDidMount() {
    this.props.store.SessionStore.getCurrentTime(true)
  }

  messageInstructor(sid) {
    this.props.parent.setState({
      examSid: sid,
      messageSid: null
    });

    toggleDrawer(null, this.props.parent, 'MessageThread');
  }

  render() {
    const configuration = this.props.exam.examSession.examConfiguration;
    const now = moment(this.props.store.SessionStore.currentTime);
    let defaultScheduleClose = false;
    let closeDatesEqual = false;

    // Check if scheduling is closed
    let scheduleCloseDate = configuration.scheduleCloseDate;

    if(moment(scheduleCloseDate).diff(moment(configuration.examCloseDate)) === 0) {
      closeDatesEqual = true;
    }

    if(
        moment(scheduleCloseDate).format('M-D-YYYY') === '1-1-2070' ||
        moment(scheduleCloseDate).diff(moment(configuration.examCloseDate)) >= 0
      ) {
      // If there’s no scheduling window set
      // or the scheduling close date is after the exam close date,
      // use the exam close date
      scheduleCloseDate = configuration.examCloseDate;
      defaultScheduleClose = true;
    }

    let closeDate = moment(scheduleCloseDate);

    if(defaultScheduleClose) {
      closeDate = moment(scheduleCloseDate);
    }

    if(closeDatesEqual) {
      scheduleCloseDate = moment(scheduleCloseDate);
    }

    const closeDiff = moment.duration(closeDate.diff(now)).asHours();
    const daysLeft = moment.duration(closeDate.diff(now)).asDays();
    let schedulingClosed = false;
    let showWarning = false;

    if(closeDiff < 0) {
      schedulingClosed = true;
    }

    if(daysLeft <= 10) {
      showWarning = true;
    }

    // Check if scheduling is open yet
    let scheduleOpenDate = configuration.scheduleOpenDate;

    const openDate = moment(scheduleOpenDate);
    const openDiff = moment.duration(openDate.diff(now)).asHours();
    let schedulingOpen = true;

    if(openDiff >= 0) {
      schedulingOpen = false;
    }

    const { store, exam } = this.props;
    const { courseData, currentTime } = store.SessionStore;


    if(
        (
          exam.examSession.status.toLowerCase() === 'scheduled' ||
          exam.examSession.status.toLowerCase() === 'in progress' ||
          exam.examSession.status.toLowerCase() === 'pending reconnection' ||
          exam.examSession.status.toLowerCase() === 'onboarding'
        )
      && courseData.instructor
      && exam.examSession.examConfiguration.examCloseDate > currentTime
    ) {
      return (
        <ExamCardScheduled
          schedulingOpen={schedulingOpen}
          schedulingClosed={schedulingClosed}
          scheduleCloseDate={scheduleCloseDate}
          messageInstructor={this.messageInstructor}
          {...this.props}
        />
      )
    } else if(
      exam.examSession.status.toLowerCase() === 'closed' ||
      exam.examSession.status.toLowerCase() === 'processing'
    ) {

      return (
        <ExamCardClosed
          schedulingOpen={schedulingOpen}
          schedulingClosed={schedulingClosed}
          scheduleCloseDate={scheduleCloseDate}
          messageInstructor={this.messageInstructor}
          {...this.props}
        />
      )
    }
    else if(
      schedulingClosed && this.props.hasAutomated && exam.examSession.examConfiguration.examCloseDate > currentTime
    ) {

      return (
        <AutomatedExamCard
          {...this.props}
          exam={exam}
          toggleDrawer={toggleDrawer}
          parent={this}
          {...this.props}
          schedulingClosed={true}
        />
      )
    }

    return (
      <ExamCardNeedsProctor
        hasAutomated={this.props.hasAutomated}
        schedulingOpen={schedulingOpen}
        schedulingClosed={schedulingClosed}
        showWarning={showWarning}
        daysLeft={daysLeft}
        scheduleCloseDate={scheduleCloseDate}
        messageInstructor={this.messageInstructor}
        defaultScheduleClose={defaultScheduleClose}
        {...this.props}
        configuration={configuration}
      />
    )
  }
})

export default translate('StudentExamCard')(StudentExamCard);



// WEBPACK FOOTER //
// ./src/app/components/StudentDashboard/StudentExamCard.js